import { render, staticRenderFns } from "./BusinessRulesTab.vue?vue&type=template&id=7fbe093f&scoped=true&"
import script from "./BusinessRulesTab.vue?vue&type=script&lang=js&"
export * from "./BusinessRulesTab.vue?vue&type=script&lang=js&"
import style0 from "./BusinessRulesTab.vue?vue&type=style&index=0&id=7fbe093f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbe093f",
  null
  
)

export default component.exports